import dxDateBox from "devextreme/ui/date_box";
import dxForm from "devextreme/ui/form";
import { DkGlobalUserSettingsService } from "../services/dk-global-user-settings.service";
import dxNumberBox from "devextreme/ui/number_box";
import { CURRENCY_FORMAT } from "../constants";

export function configureDevExtremeDefaults(globalSettings:DkGlobalUserSettingsService) {



  dxDateBox.defaultOptions({
    options: {
      useMaskBehavior: true,
      showClearButton: true,
      dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss",
      
    }
  });

  dxForm.defaultOptions({
    options: {
      labelMode: globalSettings.globalLabelMode,
      labelLocation: globalSettings.globalLabelLocation,

    }
  })

  dxNumberBox.defaultOptions({
  options: {
    onInitialized(e) {

      // Sadece dx-form içindeyse
      const isInsideDxForm = !!e?.element?.closest('.dx-form');

      if (isInsideDxForm) {
        e.element.style.maxWidth = '18ch';
        if (e.component.option('format') == CURRENCY_FORMAT) {
          e.component.option('inputAttr', { style: 'text-align: right;' });
        }
      }

    }
  }});


}
